import { Navigate, useLocation } from "react-router-dom";
import useBetterParams from "../../utils/useBetterParams.js";

export const VideoPlayerEmbedRedirect = () => {
  const { id: sessionId } = useBetterParams();
  const location = useLocation();
  return (
    <Navigate
      to={{ pathname: `/session/${sessionId}/embed`, search: location.search }}
    />
  );
};
